<section class="ifood-integracoes integration-page">
  <div class="alert alert-danger" role="alert" *ngIf="mensagemErro">
    <div class="d-flex align-items-center justify-content-between">
      <span><i class="k-icon k-i-warning mr-2"></i>{{mensagemErro}}</span>
      <button type="button" class="close" aria-label="Fechar" (click)="mensagemErro = null">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
  <div class="alert" [ngClass]="restauracaoPendente ? 'alert-warning' : 'alert-success'"
       role="status" *ngIf="mensagemRestauracao">
    <div class="d-flex align-items-center justify-content-between">
      <span><i class="fas fa-sync-alt mr-2"></i>{{mensagemRestauracao}}</span>
      <button type="button" class="close" aria-label="Fechar" (click)="mensagemRestauracao = null">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>

  <header class="page-header">
    <div>
      <h2>{{integracaoEmEdicao ? (integracaoEmEdicao.nova ? 'Adicionar loja iFood' : 'Editar integração iFood') : 'Integrações iFood'}}</h2>
      <p *ngIf="!integracaoEmEdicao">Gerencie as lojas vinculadas e os serviços ativos da integração.</p>
      <p *ngIf="integracaoEmEdicao">Configure a autorização e os serviços disponíveis para esta loja.</p>
    </div>
    <div class="header-actions" *ngIf="!integracaoEmEdicao">
      <button class="btn btn-primary" type="button" (click)="novaIntegracaoIfood()">
        <i class="k-icon k-i-plus mr-1"></i>Adicionar nova loja
      </button>
      <button class="btn btn-outline-warning" type="button" *ngIf="quantidadeLojas"
              (click)="sincronizarFormasPagamentos()" [disabled]="sincronizando">
        <i class="fas mr-1" [ngClass]="{'fa-sync-alt': !sincronizando, 'fa-spinner fa-spin': sincronizando}"></i>
        {{sincronizando ? 'Sincronizando...' : 'Sincronizar formas de pagamento'}}
      </button>
    </div>
  </header>

  <ng-container *ngIf="integracaoEmEdicao; else listagem">
    <button class="back-button" type="button" (click)="canceleEdicao()">
      <i class="fas fa-arrow-left mr-2"></i>Voltar para integrações
    </button>

    <app-form-integracao-ifood
      *ngIf="!integracaoCentralizada()"
      [empresa]="empresa"
      [integracaoIfood]="integracaoEmEdicao"
      [ifooodUserCode]="integracaoEmEdicao.ifooodUserCode"
      (salvou)="concluaEdicao($event)"
      (cancelou)="canceleEdicao()">
    </app-form-integracao-ifood>

    <app-form-integracao-ifood-centralizado
      *ngIf="integracaoCentralizada()"
      [empresa]="empresa"
      [integracaoIfood]="integracaoEmEdicao"
      (salvou)="concluaEdicao($event)"
      (cancelou)="canceleEdicao()">
    </app-form-integracao-ifood-centralizado>
  </ng-container>

  <ng-template #listagem>
    <div class="summary-grid">
      <article class="summary-card">
        <span class="summary-icon"><i class="fas fa-store"></i></span>
        <div><small>Lojas vinculadas</small><strong>{{quantidadeLojas}}</strong></div>
      </article>
      <article class="summary-card">
        <span class="summary-icon"><i class="fas fa-cube"></i></span>
        <div><small>Catalog API ativa</small><strong>{{quantidadeCatalogApiAtiva}}</strong></div>
      </article>
      <article class="summary-card order">
        <span class="summary-icon"><i class="fas fa-shopping-cart"></i></span>
        <div><small>Order API ativa</small><strong>{{quantidadeOrderApiAtiva}}</strong></div>
      </article>
      <article class="summary-card shipping">
        <span class="summary-icon"><i class="fas fa-truck"></i></span>
        <div><small>Shipping API ativa</small><strong>{{quantidadeShippingApiAtiva}}</strong></div>
      </article>
    </div>

    <div class="content-grid">
      <main class="integration-list">
        <div class="empty-state" *ngIf="!quantidadeLojas">
          <span class="empty-icon"><i class="fas fa-store"></i></span>
          <h4>Nenhuma loja iFood vinculada</h4>
          <p>Adicione uma loja para configurar os serviços da integração.</p>
          <button class="btn btn-primary" type="button" (click)="novaIntegracaoIfood()">
            <i class="k-icon k-i-plus mr-1"></i>Adicionar nova loja
          </button>
        </div>

        <article class="integration-card" *ngFor="let integracao of integracoes">
          <div class="integration-main">
            <div class="brand-column">
              <img src="/assets/icons/logo-ifood.png" alt="iFood">
              <span class="status-pill" [class.disabled]="integracao.desativado">
                <i class="fas fa-circle"></i>{{integracao.desativado ? 'Desativada' : 'Ativa'}}
              </span>
            </div>

            <div class="details-column">
              <div class="detail-row">
                <span><i class="fas fa-store"></i>Loja</span>
                <strong>{{integracao.nomeLoja || 'Loja iFood'}}</strong>
              </div>
              <div class="detail-row">
                <span><i class="fas fa-fingerprint"></i>Merchant ID</span>
                <strong class="merchant-id">{{integracao.idLoja}}</strong>
                <button class="copy-button" type="button" (click)="copieMerchantId(integracao)"
                        [attr.aria-label]="merchantIdCopiado === integracao.id ? 'Merchant ID copiado' : 'Copiar Merchant ID'">
                  <i class="fas" [ngClass]="merchantIdCopiado === integracao.id ? 'fa-check' : 'fa-copy'"></i>
                </button>
              </div>
              <div class="detail-row">
                <span><i class="fas fa-puzzle-piece"></i>Integração</span>
                <strong>{{descricaoIntegracao(integracao)}}</strong>
              </div>
              <div class="detail-row">
                <span><i class="far fa-calendar-alt"></i>Desde</span>
                <strong>{{integracao.dataAtivacao | date: 'dd/MM/yyyy'}}</strong>
              </div>
              <div class="detail-row" [class.token-expired]="tokenVencido(integracao)">
                <span><i class="fas fa-shield-alt"></i>Validade do token</span>
                <strong>{{integracao.validadeToken ? (integracao.validadeToken | date: 'dd/MM/yyyy HH:mm') : '—'}}
                  <b *ngIf="tokenVencido(integracao)"> · Vencido</b></strong>
              </div>
            </div>

            <div class="api-column">
              <div class="api-status catalog-api-status" [class.enabled]="catalogApiAtiva(integracao)">
                <div class="api-status-row">
                  <span class="api-icon"><i class="fas fa-cube"></i></span>
                  <div><strong>Catalog API</strong><small>{{catalogApiAtiva(integracao) ? 'Sim' : 'Não'}}</small></div>
                </div>
                <div class="catalog-publication" *ngIf="catalogApiAtiva(integracao)">
                  <span><i class="fas fa-upload"></i></span>
                  <div><strong>Publicação de catálogo</strong><small>Configuração vinculada à Catalog API</small></div>
                  <b class="catalog-publication-status" [class.enabled]="integracao.publicacaoCatalogoHabilitada">
                    {{integracao.publicacaoCatalogoHabilitada ? 'Habilitada' : 'Desabilitada'}}
                  </b>
                </div>
              </div>
              <div class="api-status" [class.enabled]="integracao.orderApi">
                <span class="api-icon"><i class="fas fa-shopping-cart"></i></span>
                <div><strong>Order API</strong><small>{{integracao.orderApi ? 'Sim' : 'Não'}}</small></div>
              </div>
              <div class="api-status" [class.enabled]="integracao.shippingApi">
                <span class="api-icon"><i class="fas fa-truck"></i></span>
                <div><strong>Shipping API</strong><small>{{integracao.shippingApi ? 'Sim' : 'Não'}}</small></div>
              </div>
            </div>
          </div>

          <footer class="integration-footer">
            <div class="footer-status">
              <span class="footer-shield"><i class="fas fa-shield-alt"></i></span>
              <div><small>Status da integração</small><strong [class.text-muted]="integracao.desativado">{{integracao.desativado ? 'Desativada' : 'Ativa'}}</strong></div>
            </div>
            <div class="card-actions">
              <div class="token-action">
                <button class="btn btn-outline-primary" type="button" (click)="renoveToken(integracao)"
                        [disabled]="processandoIntegracaoId != null" [attr.aria-describedby]="errosToken[integracao.id] ? 'ifood-token-error-' + integracao.id : null">
                  <i class="fas mr-1" [ngClass]="renovandoTokenId === integracao.id ? 'fa-spinner fa-spin' : 'fa-sync-alt'"></i>
                  {{renovandoTokenId === integracao.id ? 'Renovando…' : 'Renovar token'}}
                </button>
                <p class="token-error" *ngIf="errosToken[integracao.id]" role="alert" [id]="'ifood-token-error-' + integracao.id">{{errosToken[integracao.id]}}</p>
              </div>
              <button class="btn btn-outline-primary" type="button" (click)="editeIntegracao(integracao)"
                      [disabled]="processandoIntegracaoId != null">
                <i class="fas fa-pencil-alt mr-1"></i>Editar
              </button>
              <button class="btn btn-outline-success" type="button" *ngIf="integracao.desativado"
                      (click)="ativeIntegracao(integracao)" [disabled]="processandoIntegracaoId != null">
                <i class="fas fa-play-circle mr-1"></i>Ativar
              </button>
              <button class="btn btn-outline-warning" type="button" *ngIf="!integracao.desativado"
                      (click)="soliciteConfirmacao('DESATIVAR', integracao)" [disabled]="processandoIntegracaoId != null">
                <i class="fas fa-pause-circle mr-1"></i>Desativar
              </button>
              <button class="btn btn-outline-danger" type="button"
                      (click)="soliciteConfirmacao('REMOVER', integracao)" [disabled]="processandoIntegracaoId != null">
                <i class="fas fa-trash-alt mr-1"></i>Remover
              </button>
            </div>
          </footer>
        </article>
      </main>

      <aside class="api-help">
        <h4><i class="fas fa-info-circle mr-2"></i>Sobre as APIs</h4>
        <p>Entenda o papel de cada serviço da integração:</p>

        <div class="help-item catalog">
          <span><i class="fas fa-cube"></i></span>
          <div><strong>Catalog API</strong><p>Permite consultar e manter o catálogo da loja no iFood.</p></div>
        </div>
        <div class="help-item order">
          <span><i class="fas fa-shopping-cart"></i></span>
          <div><strong>Order API</strong><p>Recebe e gerencia pedidos realizados pelos clientes no iFood.</p></div>
        </div>
        <div class="help-item shipping">
          <span><i class="fas fa-truck"></i></span>
          <div><strong>Shipping API</strong><p>Solicita entregadores parceiros do iFood para pedidos captados fora da plataforma.</p></div>
        </div>

      </aside>
    </div>
  </ng-template>
</section>

<kendo-dialog *ngIf="confirmacao" [width]="500" (close)="canceleConfirmacao()">
  <kendo-dialog-titlebar>{{tituloConfirmacao()}}</kendo-dialog-titlebar>
  <p class="confirmation-message">{{mensagemConfirmacao()}}</p>
  <kendo-dialog-actions>
    <button kendoButton type="button" (click)="canceleConfirmacao()" [disabled]="processandoIntegracaoId != null">Cancelar</button>
    <button kendoButton type="button" [primary]="true" (click)="confirmeAcao()" [disabled]="processandoIntegracaoId != null">
      <i class="fas fa-spinner fa-spin mr-1" *ngIf="processandoIntegracaoId != null"></i>{{textoBotaoConfirmacao()}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
